import './caseHeading.scss';
import { Button } from '~shared/frontend/ui/button/button';
import ArrowLeft from './icons/arrowLeft';
import Key from './icons/key';
import { FunctionComponent, memo } from 'react';
import { Case as CaseType } from '~types';
import { t } from 'i18next';

interface CaseHeadingProps {
  getCase: CaseType;
}

const CaseHeading: FunctionComponent<CaseHeadingProps> = ({ getCase }) => {
  return (
    <div className="case_heading">
      <Button
        text={t('Back')}
        icon={<ArrowLeft />}
        icon_direction="left"
        isOutterHref={false}
        href={'/'}
        className="btn1_dark case_heading_btn"
      />
      <h1 className="case_heading_title">{getCase.getName}</h1>
      {getCase?.type === 1 && getCase?.getLeft > 0 && (
        <div className="case_heading_limit">
          <Key className="case_heading_limit_icon" />

          <div className="case_heading_limit_wrapper">
            <div className="case_heading_limit_title">
              Лимит открытых кейсов
            </div>
            <div>
              <span>{getCase?.getLeft}</span> / {getCase?.getLimit}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(CaseHeading);
